// ProtectedRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { connect } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
const PrivateRoutes = ({ isAuthenticated }) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/signin");
      return;
    }

    const paymentInProgress = localStorage.getItem("payment_in_progress");
    if (paymentInProgress === "true") {
      const path = window.location.pathname;
      if (
        !path.includes("/evaluation/payment/success") &&
        !path.includes("/evaluation/payment/failure") &&
        !path.includes("/evaluation/payment/cancelled") &&
        !path.includes("/funding-evaluation/payments")
      ) {
        const challengeId = localStorage.getItem("checkout_challenge_id");
        if (challengeId) {
          navigate(`/funding-evaluation/payments/${challengeId}`);
        }
      }
    }
  }, [isAuthenticated]);
  return isAuthenticated ? <Outlet /> : <Navigate to="/signin" />;
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(PrivateRoutes);
